// extracted by mini-css-extract-plugin
module.exports =  {"root":"Card-module__root--nKUtO","small":"Card-module__small--gk1Fa","medium":"Card-module__medium--pZW9A","large":"Card-module__large--q19CF"};